module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ActionEditorSuccessAlert":"Призыв к действию создан!","ActionEditorErrorAlert":"Что-то пошло не так","ActionEditorDefaultName":"Призыв к действию"},"en":{"ActionEditorSuccessAlert":"The call to action has been created!","ActionEditorErrorAlert":"Something went wrong","ActionEditorDefaultName":"Call to action"}}')
  delete Component.options._Ctor
}
